import { WebApiService } from './plugins/webApiService';
import AdminWsController from './rdp-microservice/controller/AdminWsController'

export default class apiDataSourceRdp {
	/**
	 * * Контроллер для управления админами
	 */
	AdminWsController: AdminWsController;
	constructor(cookieName?: string) {
		this.AdminWsController = new AdminWsController(undefined, cookieName, "appWebSettings.json", "apiUrl");
	}

}
